export const REGISTRY_URL = '/registry'
